const experienceData = [
  {
    jobTitle: "JCAI Inc.",
    jobRole: "Full Stack Developer",
    startDate: "Jan 2023",
    endDate: "June 2025",
    technologies: [
      "TypeScript",
      "React",
      "Redux",
      "Node.js",
      "Express",
      "Tailwind CSS",
      "Python",
      "Django",
      "PostgreSQL",
      "AWS",
      "Redis",
      "Docker",
      "Kubernetes",
    ],
    acomplishments: [
      "Built a Personnel Data Dashboard using TypeScript, React, Redux, Python/Django and PostgreSQL to replace customers' manual data tracking process, adding input validation that reduced data entry errors by 90%",
      "Overhauled an aircraft detection application by using Docker/Kubernetes for deployment and replacing HTTP polling with Node.js WebSockets, cutting data latency between microservices from 2s to 200ms",
      "Implemented and maintained Node.js/Express.js RESTful APIs on PostgreSQL with rate limiting, optimized SQL queries and Redis caching, handling 150K+ API requests daily with p95 response times under 150ms",
      "Developed a responsive React and Tailwind CSS component library with the Design and Product teams, using lazy loading and client-side caching to cut average page load times across the customer facing web app from 5s to 1.5s",
      "Resolved recurring failed deployments across an AWS S3 file-processing pipeline by leveraging AWS CodeBuild and Datadog logs, and working with on-call developers to restore services and minimize downtime for 10,000+ users",
      "Prevented regressions across multiple deployments by implementing robust unit, integration, and UI tests into an AWS CI/CD pipeline using Jest, React Testing Library (Frontend) and PyTest (Backend), increasing test code coverage up from 55% to 92%",
    ],
    mobileAcomplishments: [
      "Built a Personnel Data Dashboard using TypeScript, React, Redux, Python/Django and PostgreSQL to replace customers' manual data tracking process, adding input validation that reduced data entry errors by 90%",
      "Overhauled an aircraft detection application by using Docker/Kubernetes for deployment and replacing HTTP polling with Node.js WebSockets, cutting data latency between microservices from 2s to 200ms",
      "Implemented and maintained Node.js/Express.js RESTful APIs on PostgreSQL with rate limiting, optimized SQL queries and Redis caching, handling 150K+ API requests daily with p95 response times under 150ms",
      "Developed a responsive React and Tailwind CSS component library with the Design and Product teams, using lazy loading and client-side caching to cut average page load times across the customer facing web app from 5s to 1.5s",
      "Resolved recurring failed deployments across an AWS S3 file-processing pipeline by leveraging AWS CodeBuild and Datadog logs, and working with on-call developers to restore services and minimize downtime for 10,000+ users",
      "Prevented regressions across multiple deployments by implementing robust unit, integration, and UI tests into an AWS CI/CD pipeline using Jest, React Testing Library (Frontend) and PyTest (Backend), increasing test code coverage up from 55% to 92%",
    ],
  },
];

export default experienceData;
